import { DynamicObject } from './commonTypes';
import { Languages } from './constants/stringConstants';

export const getActorInfo = (actors: string[]) => {
  let actorInfo: string[][] = [];
  if (actors?.length) {
    actorInfo = actors.map((actor) =>
      actor.split(':').map((actorWithSpace) => actorWithSpace.trim())
    );
  }

  return actorInfo;
};

export const getActorsName = (actorsInfo: string[][]) => {
  const actors: string[] = [];
  if (actorsInfo?.length) {
    actorsInfo.map((actorInfo: string[]) => {
      actors.push(actorInfo[0]);
    });
  }
  return actors;
};

export const getFormattedLanguages = (languages: string[]) => {
  const langaugeText = languages?.map((language: string) => {
    const langaugeText = (Languages as DynamicObject)[language];
    return langaugeText;
  });
  return langaugeText;
};
